import { actions, AppState } from "../data/redux-state"
import { Container } from "reactstrap"
import { VariableDropdown } from "./VariableDropdown"
import { ChartUI } from "./ChartUI"
import * as React from "react"
import { useEffect } from "react"
import { connect } from "react-redux"
import {
  extractIndicatorClassFromPathname,
  IndicatorClass,
  switchIndicatorClass,
} from "../data/indicator-class"
import { globalHistory } from "@reach/router"
import { IntlShape, useIntl } from "gatsby-plugin-intl"
import { fetchSourceJson } from "../data/json-provider"
import { globalStore } from "./Index"
import { Spinner } from "spin.js"
import "../assets/stylesheets/spin.css"
import { MultiRegionsDropdown } from "./MultiRegionsDropdown"
import { MultiSubvariablesDropdown } from "./MultiSubvariablesDropdown"
import { MultiCoVariablesDropdown } from "./MultiCoVariablesDropdown"
import { CoVarOption, extractCoVarOptions } from "../utils/extractCoVariables"

function getSubTitle(indicatorClass: IndicatorClass, intl: IntlShape) {
  return intl.formatMessage({ id: "indicatorClasses." + indicatorClass })
}

const spinOptions = {
  lines: 13, // The number of lines to draw
  length: 38, // The length of each line
  width: 17, // The line thickness
  radius: 45, // The radius of the inner circle
  scale: 1, // Scales overall size of the spinner
  corners: 1, // Corner roundness (0..1)
  speed: 1, // Rounds per second
  rotate: 0, // The rotation offset
  animation: "spinner-line-fade-quick", // The CSS animation name for the lines
  direction: 1, // 1: clockwise, -1: counterclockwise
  color: "#fddc05", // CSS color or array of colors
  fadeColor: "transparent", // CSS color or array of colors
  top: "60%", // Top position relative to parent
  left: "50%", // Left position relative to parent
  shadow: "0 0 1px transparent", // Box-shadow for the lines
  zIndex: 2000000000, // The z-index (defaults to 2e9)
  className: "spinner", // The CSS class to assign to the spinner
  position: "absolute", // Element positioning
}
let spinner: Spinner | null = null
function startSpinner() {
  const spinTarget: HTMLElement = document.querySelector(".text-muted")!
  if (!spinner) {
    spinner = new Spinner(spinOptions)
  }
  spinner.spin(spinTarget)
}
function stopSpinner() {
  spinner?.stop()
  spinner = null
}

const InnerMainUI = (props: AppState) => {
  const intl = useIntl()
  const coVarOptions: CoVarOption[] = extractCoVarOptions(props, intl)
  useEffect(() => {
    const initialIndicatorClass = extractIndicatorClassFromPathname(
      window.location.pathname
    )
    switchIndicatorClass(initialIndicatorClass)

    globalHistory.listen((e) => {
      const pathName = e.location.pathname
      let newIndicatorClass = extractIndicatorClassFromPathname(pathName)
      switchIndicatorClass(newIndicatorClass)
    })
  }, [])
  useEffect(() => {
    if (props.geoVariable) {
      startSpinner()
      fetchSourceJson(props.geoVariable)
        .then((sourceJson) => {
          globalStore.dispatch(actions.setSourceJson(sourceJson))
          globalStore.dispatch(actions.setJsonLoadError(null))
        })
        .catch((e) => {
          console.error(e)
          const errorMsg = "failed to fetch " + props.geoVariable
          console.error(errorMsg)
          globalStore.dispatch(actions.setJsonLoadError(errorMsg))
          globalStore.dispatch(actions.setSourceJson({} as GeoVarJson))
        })
        .finally(() => {
          stopSpinner()
        })
    }
  }, [props.geoVariable])

  // Show placeholder for EWM-GLO
  if (props.indicatorClass === "EWM-GLO") {
    const placeholderText = intl.formatMessage({ id: "ewmGloPlaceholder.title" })
    const paragraph1 = intl.formatMessage({ id: "ewmGloPlaceholder.paragraph1" })
    const paragraph2 = intl.formatMessage({ id: "ewmGloPlaceholder.paragraph2" })
    const link = intl.formatMessage({ id: "ewmGloPlaceholder.link" })

    return (
      <div>
        <Container style={{ marginTop: "3px" }}>
          <div className="text-center">
            <div
              style={{
                color: "black",
                fontSize: "large",
                fontWeight: "bold",
              }}
            >
              {getSubTitle(props.indicatorClass, intl)}
            </div>
          </div>
        </Container>
        <Container style={{ marginTop: "30px" }}>
          <div style={{ textAlign: "left", lineHeight: "1.6" }}>
            <p style={{ fontSize: "1rem", marginBottom: "1rem", fontWeight: "bold" }}>
              {placeholderText}
            </p>
            <p style={{ fontSize: "0.95rem", marginBottom: "1rem" }}>
              {paragraph1}
            </p>
            <p style={{ fontSize: "0.95rem", marginBottom: "1rem" }}>
              {paragraph2}
              <a href={link} target="_blank" rel="noopener noreferrer">
                {link}
              </a>
            </p>
          </div>
        </Container>
      </div>
    )
  }

  return (
    <div>
      {props.sourceJson && props.subVariable && props.geoRegion && (
        <>
          <Container style={{ marginTop: "3px" }}>
            <div className="text-center">
              {/* <div style={{ fontWeight: "bold", fontSize: "x-large" }}>
                GCCI - Graz Climate Change Indicators
              </div> */}
              <div
                style={{
                  color: "black",
                  fontSize: "large",
                  fontWeight: "bold",
                }}
                // className="text-muted"
              >
                {getSubTitle(props.indicatorClass, intl)}
              </div>
            </div>
          </Container>
          <Container>
            <div className="text-center">
              <VariableDropdown {...props} />
              <div style={{ height: "5px" }} />
              <MultiSubvariablesDropdown {...props} />
              {/* <div style={{ height: "5px" }} /> */}
              {coVarOptions.length > 0 && (
                <MultiCoVariablesDropdown
                  coVarOptions={coVarOptions}
                  appState={props}
                />
              )}
              <div style={{ height: "5px" }} />
              <MultiRegionsDropdown {...props} />

            </div>
          </Container>
          {props.jsonLoadError && (
            <Container className="pt-3 text-center">
              <div
                style={{
                  color: "red",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  padding: "10px",
                }}
              >
                {props.jsonLoadError}
              </div>
            </Container>
          )}
          <Container style={{ height: "67vh" }} className="pt-3 text-center">
            <ChartUI {...props} />
          </Container>
        </>
      )}
    </div>
  )
}

export const MainUI = connect((state: AppState) => {
  return state
})(InnerMainUI)
